import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Checkbox, Tooltip, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import AttributesService from "../../../../../../API/orders/orders/organization/AttributesService";
import {useLocation, useNavigate} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../../../../utils/EditLocalStoragePagesData";
import ButtonCreate from "../../../../button/ButtonCreate";
import NameModal from "../../../../modal/NameModal";
import {constantsErrorMessages} from "../../../../../../Constants";
import ModalAlert from "../../../customer-detales/ModalAlert";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";

const AttributesTable = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        getStartPageSize()
        AttributesService.getAll().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const setEnabledDefault = (row) => {
        AttributesService.unableDefault(row.id)
            .then(function () {
                setData(prev => prev.map(el => el.id === row.id
                    ? {...el, enabledDefault: true}
                    : {...el, enabledDefault: false}
                ))
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const handleAdd = () => {
        setModal(true)
    }
    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(null)
    }

    const handleUpdate = (data) => {
        setLoading(true)
        AttributesService.update(data, currentEditRowData.id)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                handleModalAlert("Данные изменены", 'success')
                handleClose()
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const handleSubmit = (data) => {
        setLoading(true)
        AttributesService.save({...data, enabled: true})
            .then(function (response) {
                setData(prev => [...prev, response.data])
                setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
                handleModalAlert("Данные добавлены", 'success')
                handleClose()
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const handleDelete = (row) => {
        AttributesService.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                setTableOptions((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };
    const handleStatus = (data) => {
        AttributesService.unable(data.id, !data.enabled)
            .then(function () {
                setData(prev => prev.map(el => el.id === data.id ? {...el, enabled: !el.enabled} : el))
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleEdit = (row) => {
        setCurrentEditRowData(row);
        setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                minSize: 500,

            },
            {
                id: 'enabledDefault',
                header: 'По умочанию',
                accessorKey: 'enabledDefault',
                maxSize: 130,
                enableColumnActions: false,
                Cell: ({cell, row}) => <Radio
                    onChange={() => setEnabledDefault(row.original)}
                    checked={row.original.enabledDefault}
                    sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
                />
            },
            {
                id: 'enabled',
                header: 'Статус',
                accessorKey: 'enabled',
                maxSize: 80,
                enableColumnActions: false,

                Cell: ({cell, row}) => <Checkbox
                    onChange={() => handleStatus(row.original)}
                    checked={row.original.enabled}
                    sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
                />
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ],
        [data, setData],
    );

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]
    return (
        <Box
            sx={{
                overflow: 'auto',
                maxWidth: 'calc(100vw - 410px)',
            }}
        >
            <Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
            >
                <Typography sx={{fontSize: "24px", fontWeight: 700}}>Атрибуты заказов</Typography>
                <ButtonCreate
                    text={"Добавить атрибуты"}
                    width={220}
                    onClick={handleAdd}
                />
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: `calc(100vh - 420px)`
                    }
                }}
                muiTableBodyCellProps={({cell, table}) => {
                    return ({
                        sx: () => ({
                            p: cell.column.id === "name" ? '0px 0px 0px 10px' : 0,
                            m: '0px 0px 0px 0px',
                            border: "none",
                            textAlign: cell.column.id === "name" ? "left" : "center",
                            "&:after": {
                                display: "none",
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:first-of-type": {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },
                            "& li": {
                                listStyleType: "none",
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }
                            }
                        })
                    })
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: 10,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={data}
                getRowId={(originalRow) => originalRow.id}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                rowCount={tableOptions.totalElements}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    pagination: {pageIndex: 0, pageSize: 100},
                }}
                localization={MRT_Localization_RU}
                enableRowActions={true}
                enableToolbarInternalActions={false}
            />
            <NameModal
                title={currentEditRowData ? "Изменить" : "Добавить"}
                open={modal} onClose={handleClose}
                handleSubmit={currentEditRowData ? handleUpdate : handleSubmit}
                initValue={currentEditRowData}
                loading={loading}/>
        </Box>
    );
};

export default AttributesTable;